module.exports = __webpack_public_path__ + "static/media/full-edu.57a542ab.png";